// extracted by mini-css-extract-plugin
module.exports = {"divider":"divider__2CUhm","collapsed":"collapsed__rPd6z"};